import { useCallback, useEffect } from 'react';

import { useAccountCompanyIds } from 'application/hooks';
import { DEFAULT_POINT_STATUSES } from 'application/pages/PointsPage/renderer/PointsToolbar/consts';

import useAllPointList from 'domain/point/useAllPointList';

export const usePointsTabPresenter = () => {
  const companyIds = useAccountCompanyIds();

  const allPointList = useAllPointList({
    companyIds,
    playingStatuses: DEFAULT_POINT_STATUSES,
    hasVideoSupport: true,
  });

  useEffect(() => {
    if (companyIds.length > 0) {
      allPointList.request();
    }
  }, [companyIds]);

  const loadMore = useCallback(async () => {
    if (allPointList.loading || !allPointList.paginationInfo?.hasNextPage) {
      return;
    }

    allPointList.fetchMore(allPointList.paginationInfo?.page);
  }, [allPointList]);

  return {
    allPointList,
    loadMore,
  };
};
